module.exports = __webpack_public_path__ + "static/media/P1000-sm-open.89b44514.svg";